import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/AuthContext';
import LoginModal from '../../auth/components/LoginModal';
import lessons from './lessons';
import LessonCard from './LessonCard';
import LessonPlayer from './LessonPlayer';
import './ELearningPage.css';

export default function ELearningPage() {
  const { t } = useTranslation('app');
  const { isAuthenticated } = useAuth();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const triggerRef = useRef(null);
  const selectedLesson = isAuthenticated ? lessons.find(lesson => lesson.id === selectedId) : null;

  useEffect(() => {
    if (!isAuthenticated) {
      setSelectedId(null);
    }
  }, [isAuthenticated]);

  const openLesson = (id, trigger) => {
    triggerRef.current = trigger;
    if (!isAuthenticated) {
      setIsLoginModalOpen(true);
      return;
    }
    setSelectedId(id);
  };
  const closeLesson = () => {
    setSelectedId(null);
    triggerRef.current?.focus();
  };

  return (
    <main className="learning-page">
      <div className="learning-container">
        <header className="learning-header">
          <span className="learning-eyebrow">Hi-Portal</span>
          <h1>{t('navigation.elearning')}</h1>
          <p>{t('learning.intro')}</p>
        </header>
        <section aria-labelledby="learning-products-title">
          <h2 id="learning-products-title">{t('learning.productsTitle')}</h2>
          <div className="learning-grid">
            {lessons.map(lesson => (
              <LessonCard key={lesson.id} lesson={lesson} selected={selectedLesson?.id === lesson.id} onSelect={openLesson} t={t} />
            ))}
          </div>
        </section>
        <div id="learning-player">
          {selectedLesson
            ? <LessonPlayer lesson={selectedLesson} onClose={closeLesson} t={t} />
            : <p className="learning-empty">{t('learning.emptyState')}</p>}
        </div>
      </div>
      <LoginModal
        open={isLoginModalOpen}
        onClose={() => {
          setIsLoginModalOpen(false);
          triggerRef.current?.focus();
        }}
      />
    </main>
  );
}
